<script>

import axios from 'axios';

const mainUrl = process.env.VUE_APP_API_URL;

export default class AtendimentoWhatsappRepository{
    
    async getAgendamentos(token,page){
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers});
        return response;

    }

    async getConversas(id,token){
        console.log('chamei repo')
        const baseURL = `${mainUrl}conversas-whatsapp/por-lista/${id}`;
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers});
        return response;
    }

    async getConversaById(conversaId, token){
        const baseURL = `${mainUrl}conversas-whatsapp/conversa/${conversaId}`;
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers});
        return response;
    }

    async finalizarAtendimento(id,token){
        console.log(token)
        const baseURL = `${mainUrl}conversas-whatsapp/lista/${id}/status`;
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.patch(baseURL,{headers});
        return response;
    }

    async createMensagem(rawdata,token){
        
        const baseURL = `${mainUrl}whatsapp/funcCloudApi/send`;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

    async enviarTemplate(rawdata,token){
        
        const baseURL = `${mainUrl}whatsapp/funcCloudApi/template`;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }


    async getTemplates(token){
        const baseURL = `${mainUrl}whatsapp/template/index`;
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers});
        return response;
    }


}
</script>
